module.exports = __webpack_public_path__ + "static/media/app2.c6a0fbaa.png";